module.exports = __webpack_public_path__ + "img/overview-cll-footnote.f861921b.png";